import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    static targets = ["wrapper"];

    connect() {
        this.checkDisplay();
    }

    disconnect() {

    }
    closePopin() {
        this.element.removeAttribute("data-open");
    }
    openPopin() {
        this.element.setAttribute("data-open", "true");
        let wrapper = this.wrapperTarget;
        let maxHeight = window.innerHeight - wrapper.getBoundingClientRect().top - 100;
        wrapper.style.maxHeight = maxHeight+"px";
    }
    hideNews() {
        localStorage.setItem("flashNewsLastTime", this.element.dataset.time);
        this.element.removeAttribute("data-show");
    }
    checkDisplay() {
        const storedTime = localStorage.getItem('flashNewsLastTime');
        const elementTime = this.element.dataset.time;
        if (storedTime === elementTime) {
            return false;
        }
        setTimeout(() => {
            this.element.setAttribute("data-show", "true");
        }, 1000);

    }
}